(() => {
  const header = document.querySelector('.header');
  const section = document.querySelector('.large-hero-banner-wrapper');
  const logo = document.querySelector('.header__heading-logo');
  const announcement = document.querySelector('.announcement-wrapper');
  const menuItems = document.querySelectorAll('.header__menu-item');
  const detailElements = document.querySelectorAll('[id^="Details-"]'); // Select all elements with IDs starting with "Details-"
  let lastScrollTop = 0;

  const updateHeaderState = () => {
    const isDetailOpen = Array.from(detailElements).some((detail) =>
      detail.hasAttribute('open')
    );

    if (isDetailOpen) {
      header.classList.add('header--opaque');
      header.classList.remove('header--transparent');
      logo.classList.remove('header__heading-logo--white'); 
      menuItems.forEach((item) => item.classList.remove('header__menu-item--white'));
      return; 
    }

    if (!section) {
      header.classList.add('header--opaque');
      header.classList.remove('header--transparent');
      logo.classList.remove('header__heading-logo--white'); 
      menuItems.forEach((item) => item.classList.remove('header__menu-item--white'));
    }
    
    const sectionBottom = section?.getBoundingClientRect().bottom || 0;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const headerHeight = header.offsetHeight;
    
    if (sectionBottom > headerHeight && section) {
      header.classList.add('header--transparent');
      header.classList.remove('header--opaque');
      logo.classList.add('header__heading-logo--white'); 
      menuItems.forEach((item) => item.classList.add('header__menu-item--white'));
    } else {
      header.classList.add('header--opaque');
      header.classList.remove('header--transparent');
      logo.classList.remove('header__heading-logo--white'); 
      menuItems.forEach((item) => item.classList.remove('header__menu-item--white'));
    }

    if (scrollTop > lastScrollTop && sectionBottom <= header.offsetHeight) {
      header.classList.add('header--shadow');
    } else if (scrollTop === 0 || sectionBottom > header.offsetHeight) {
      header.classList.remove('header--shadow');
    }

    if (scrollTop < lastScrollTop) {
      announcement.classList.remove('announcement-wrapper--hidden');
      announcement.classList.add('sticky');
    
      if (window.innerWidth <= 768) {
        header.style.top = '33px';
      } else {
        header.style.top = '35px';
      }
    } else if (scrollTop > lastScrollTop) {
      announcement.classList.add('announcement-wrapper--hidden');
      announcement.classList.remove('sticky');
      header.style.top = '0';
    }
    
    if (scrollTop === 0) {
      announcement.classList.remove('announcement-wrapper--hidden');
      if (window.innerWidth <= 768) {
        header.style.top = '33px';
      } else {
        header.style.top = '35px';
      }
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  };
  
  const handleDetailsToggle = () => {
    const isDetailOpen = Array.from(detailElements).some((detail) =>
      detail.hasAttribute('open')
    );

    if (isDetailOpen) {
      menuItems.forEach((item) => item.classList.remove('header__menu-item--white'));
    } else {
      menuItems.forEach((item) => item.classList.add('header__menu-item--white'));
    }
  };

  detailElements.forEach((detail) => {
    detail.addEventListener('toggle', handleDetailsToggle);
  });

  document.addEventListener('scroll', updateHeaderState);
  updateHeaderState();

  header.addEventListener('mouseenter', () => {
    header.classList.add('header--shadow');
    header.classList.add('header--opaque');
    logo.classList.remove('header__heading-logo--white'); 
    header.classList.remove('header--transparent');
  });

  header.addEventListener('mouseleave', () => {
    if(section) {
      const sectionBottom = section.getBoundingClientRect().bottom;
    if (sectionBottom > 0) {
      header.classList.add('header--transparent');
      header.classList.remove('header--opaque');
      logo.classList.add('header__heading-logo--white'); 
      header.classList.remove('header--shadow');
    }
    }
  });
})();